module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ComponentsSpinnersWrapper', {
    staticStyle: {
      "min-height": "60vh"
    },
    attrs: {
      "showContent": _vm.isLoaded
    }
  }, [_c('Breadcrumbs', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbsExtended
    }
  }, [_c('AppCardTotalLayout', [_c('AppHeading', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), (_vm.space) ? _c('AppPicture', {
    attrs: {
      "slot": "slider",
      "image": _vm.image
    },
    slot: "slider"
  }) : _vm._e(), (_vm.isLoaded) ? _c('template', {
    slot: "sidebar"
  }, [(_vm.space && _vm.space.partner_name) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Организация:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.space.partner_name))])], 1) : _vm._e(), (_vm.partner && _vm.partner.contacts.address) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Адрес:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.partner.contacts.address))])], 1) : _vm._e(), (_vm.space && _vm.space.address) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Расположение:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.space.address))])], 1) : _vm._e(), (_vm.space && _vm.space.area) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Площадь, кв.м.:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.space.area))])], 1) : _vm._e(), (_vm.space && _vm.space.max_persons) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Вместимость, чел.:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.space.max_persons))])], 1) : _vm._e(), (_vm.space && _vm.space.object_type && _vm.space.object_type.length) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Тип помещения:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.space.object_type))])], 1) : _vm._e(), (!!_vm.space) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Для ОВЗ:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.isOvz))])], 1) : _vm._e(), (!!_vm.space && _vm.space.status) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Статус:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.space.status))])], 1) : _vm._e()]) : _vm._e(), _c('template', {
    slot: "main"
  }, [_c('TabsMenu', {
    attrs: {
      "items": _vm.menu
    },
    on: {
      "change": _vm.changeTabMenu
    }
  }), (_vm.activeTab === 1 && _vm.inventory.length) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, _vm._l((_vm.inventory), function(item, index) {
    return _c('div', {
      staticClass: "mb-3"
    }, [_c('div', {
      staticClass: "d-flex mb-1"
    }, [_c('AppHeading', {
      attrs: {
        "level": "2",
        "mod": "bold"
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _c('div', {
      staticClass: "d-flex mb-1"
    }, [_c('AppHeading', {
      attrs: {
        "level": "4",
        "mod": "bold"
      }
    }, [_vm._v("Тип оборудования: ")]), _c('AppText', {
      attrs: {
        "mod": "small"
      }
    }, [_vm._v(_vm._s(item.type_name))])], 1), _c('div', {
      staticClass: "d-flex mb-1"
    }, [_c('AppHeading', {
      attrs: {
        "level": "4",
        "mod": "bold"
      }
    }, [_vm._v("Количество: ")]), _c('AppText', {
      attrs: {
        "mod": "small"
      }
    }, [_vm._v(_vm._s(item.quantity))])], 1)])
  }), 0) : _vm._e(), _c('AppButtonNew', {
    attrs: {
      "to": {
        path: ("/organization/" + _vm.partnerId + "/space")
      }
    }
  }, [_vm._v("Еще помещения организации")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045c0051","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/organization-space/OrganizationSpace.vue
// module id = 912da1939f87435779f0
// module chunks = 78